import { render } from "./RecentAnnouncement.vue?vue&type=template&id=096b33eb"
import script from "./RecentAnnouncement.vue?vue&type=script&lang=js"
export * from "./RecentAnnouncement.vue?vue&type=script&lang=js"

import "./RecentAnnouncement.vue?vue&type=style&index=0&id=096b33eb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__